import type { AccommodationDetail, Site } from '@/api/accommodation/types'
import type { LocationDiscount } from '@/api/accommodation/hooks'
import type { PriceGuaranteeComparison } from '@/lib/track'

export type SiteWithPrice = Site & { averagePrice: number }

export function getSitesWithPrice(accommodation: AccommodationDetail): SiteWithPrice[] {
  return (accommodation.sites ?? []).filter(
    (site): site is SiteWithPrice => typeof site.averagePrice === 'number' && site.averagePrice > 0,
  )
}

export function buildComparison(discount: LocationDiscount, sitesWithPrice: SiteWithPrice[]): PriceGuaranteeComparison {
  const competitorPrices = [...sitesWithPrice.map((site) => site.averagePrice), discount.maxPrice]
  return {
    ourPrice: discount.minPrice,
    directPrice: discount.maxPrice,
    sitePrices: Object.fromEntries(sitesWithPrice.map((site) => [site.site, site.averagePrice])),
    isCheapest: competitorPrices.every((price) => discount.minPrice < price),
  }
}

export function guaranteeSubtitle(isCheapest: boolean): string {
  return isCheapest ? 'Ověřili jsme, že naše cena je nejnižší.' : 'Porovnejte cenu s dalšími weby.'
}
